import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import times from "lodash/times";
import React from "react";
import styled from "styled-components";
export var ProgressDots = function(param) {
    var progress = param.progress, total = param.total;
    return /*#__PURE__*/ _jsx(Row, {
        children: times(total, function(num) {
            return /*#__PURE__*/ _jsx(Dot, {
                $color: num === progress ? Core.surface.enabled : undefined
            }, num);
        })
    });
};
var Dot = styled.div.withConfig({
    componentId: "sc-29e84956-0"
})([
    "height:5px;width:5px;border-radius:50%;background-color:",
    ";margin:2.5px;"
], function(param) {
    var $color = param.$color;
    return $color || Core.surface.subdued;
});
